import Encrypt from "@/Fwk/Encrypt/Encrypt";
import AESHelper from "@/Fwk/Encrypt/AESHelper";
import Util from "@/Master/Util";

export default class DataMgr {
    static tag: string = `[DataMgr]`;

    static get isEncrypted(){
        if (Util.isDev){
            return false;
        }


        return true;
    };

    /**
     * 储存数据到本地
     * @param key - 储存的键名
     * @param value - 要储存的值，可以是对象或字符串
     */
    static setStorage(key: string, value: any): void {
        if (!key || value === undefined || value === null) {
            // Util.logError(`key=${key},value=${value} => 无效的键或值，无法存储到 localStorage。`);
            return;
        }
        let v: string = value;
        if (typeof v === 'object') {
            v = JSON.stringify(v);
            v = 'obj-' + v;
        } else if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') {
            v = 'str-' + v.toString();
        } else {
            console.error(`${DataMgr.tag} key=${key} type=${typeof v} => 不是支持的数据类型，无法保存到 localStorage。`);
            return;
        }

        try {
            // 加密 key
            this.saveData(key, v);
        } catch (e) {
            console.error(`${DataMgr.tag} key=${key} type=${typeof v} => 设置 localStorage 时出错: `, e);
        }
    }

    /**
     * 获取本地储存的数据
     * @param key - 要获取的键名
     * @returns - 返回储存的值，自动解析为原始类型
     */
    static getStorage(key: string): any | null {
        if (!key) {
            // Util.logError(`${DataMgr.tag} key=${key} 无效的键，无法从 localStorage 获取数据。`);
            return null;
        }
        try {
            // 加密 key
            const v: string | null = this.getData(key);
            if (!v) {
                return null;
            }
            if (v.startsWith('obj-')) {
                return JSON.parse(v.slice(4));
            } else if (v.startsWith('str-')) {
                return v.slice(4);
            } else {
                console.error(`key=${key} 类型未知。`);
                return null;
            }
        } catch (e) {
            // Util.logError(`${DataMgr.tag} key=${key} 获取 localStorage 时发生错误: `, e);
            return null;
        }
    }

    static clear(key:string){
        if (this.isLocalStorage){
            // 加密 key
            const encryptedKey = AESHelper.EncryptWeb(key, Encrypt.getSecretKey);
            window.localStorage.removeItem(encryptedKey);
        }
    }

    static clearAll(key:string){
        if (this.isLocalStorage){
            window.localStorage.clear();
        }
    }

    /**
     * 一个判断开关
     * @param key - 键名
     * @returns - 如果存储的值为 '1' 则返回 true，否则返回 false
     */
    static hasKeySwitch(key: string): boolean {
        return this.getStorage(key) === '1';
    }

    /**
     * 保存加密数据到 localStorage
     * @param key - 键名
     * @param data - 要保存的数据（已处理的字符串）
     */
    static saveData(key: string, data: string): void {
        if (this.isLocalStorage){
            if (this.isEncrypted){
                const encryptedKey = AESHelper.EncryptWeb(key, Encrypt.getSecretKey);
                const encryptedData: string = AESHelper.EncryptWeb(data, Encrypt.getSecretKey);
                window.localStorage.setItem(encryptedKey, encryptedData);
            }
            else {
                window.localStorage.setItem(key, data);
            }
        }
    }

    static get isLocalStorage():boolean{
        // 检查是否在浏览器环境
        return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
    }

    /**
     * 获取并解密 localStorage 中的数据
     * @param key - 键名
     * @returns - 解密后的字符串，如果解密失败则返回 null
     */
    static getData(key: string): string | null {
        if (!this.isLocalStorage){
            return ''
        }
        if (this.isEncrypted){
            const encryptedKey = AESHelper.EncryptWeb(key, Encrypt.getSecretKey);
            let encryptedData = window.localStorage.getItem(encryptedKey);
            if (encryptedData === undefined || encryptedData === null || encryptedData === '') {
                return '';
            }
            try {
                const decryptedData: string = AESHelper.DecryptWeb(encryptedData, Encrypt.getSecretKey);
                return decryptedData || '';
            } catch (e) {
                console.error(`${DataMgr.tag} key=${key} 解密数据时出错: `, e);
                return '';
            }
        }
        else {
            try {
                let data = window.localStorage.getItem(key);
                return data || '';
            } catch (e) {
                console.error(`${DataMgr.tag} key=${key} 解密数据时出错: `, e);
                return '';
            }
        }
    }

    /**
     * 解密传入的字符串数据
     * @param strData - 加密的字符串数据
     * @returns - 解密后的字符串，如果解密失败则返回空字符串
     */
    static getDecryptDataStr(strData: string): string {
        try {
            const data = AESHelper.DecryptWeb(strData);
            return data || '';
        } catch (e) {
            console.error(`${DataMgr.tag} 解密字符串数据时出错: `, e);
            return '';
        }
    }
}

